import * as React from "react";
import type { SVGProps } from "react";
const SvgSynchronise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#synchronise_svg__a)">
      <path d="M20 11.99a1 1 0 0 1-.99-.86c-.54-3.88-4.13-6.59-8.01-6.06a7.13 7.13 0 0 0-4.81 2.92H8c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.56.45-1 1-1s1 .45 1 1v1.28a9.1 9.1 0 0 1 5.72-3.18c4.98-.69 9.58 2.79 10.27 7.76.08.55-.31 1.05-.85 1.13H20zM12.02 21C7.55 21 3.64 17.7 3 13.15c-.08-.55.31-1.05.85-1.13.55-.08 1.05.31 1.13.85.54 3.88 4.13 6.59 8.01 6.06a7.13 7.13 0 0 0 4.81-2.92h-1.81c-.55 0-1-.45-1-1s.45-1 1-1H20c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1.28A9.15 9.15 0 0 1 12.02 21" />
    </g>
    <defs>
      <clipPath id="synchronise_svg__a">
        <path fill="#fff" d="M3 3h18v18H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSynchronise;
